<template>
  <div id="app">
    <FlashMessage></FlashMessage>
    <app-header></app-header>
    <router-view></router-view>
    <app-footer></app-footer>
    <cart-pill></cart-pill>
  </div>
</template>

<script>
    import appHeader from './views/common/Header.vue'
    import appFooter from './views/common/Footer.vue'
    import CartPill from './views/common/CartPill.vue'

    export default {
        name: 'app',
        components: {
            appHeader,
            appFooter,
            CartPill
        }
    }
</script>

<!-- Global (non-scoped) so it reaches the library-rendered FlashMessage markup.
     Adds a visible close (×) affordance. The toast body is already click-to-dismiss
     by default, and the × is part of that body, so clicking it uses the existing
     dismiss behaviour — no functionality changed. -->
<style>
    ._vue-flash-msg-body {
        position: relative;
        padding-right: 34px;
        cursor: pointer;
    }

    ._vue-flash-msg-body::after {
        content: "\00d7";
        position: absolute;
        top: 50%;
        right: 8px;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        font-weight: bold;
        color: #fff;
        background: rgba(0, 0, 0, 0.35);
        border-radius: 50%;
        opacity: 1;
        transition: background 0.15s ease;
    }

    ._vue-flash-msg-body:hover::after {
        background: rgba(0, 0, 0, 0.6);
    }

    /* Thinner toast: trim only the top/bottom padding, keep left/right spacing. */
    ._vue-flash-msg-body ._vue-flash-msg-body__content {
        padding-top: 0;
        padding-bottom: 0;
    }

    /* Fly-to-cart animation: floating clone of the product image. */
    .fly-to-cart-clone {
        position: fixed;
        z-index: 99999;
        pointer-events: none;
        border-radius: 6px;
        object-fit: cover;
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
        will-change: transform, opacity;
    }

    /* Cart count "bump" when an item lands. */
    @keyframes cart-bump {
        0%   { transform: scale(1); }
        40%  { transform: scale(1.45); }
        70%  { transform: scale(0.9); }
        100% { transform: scale(1); }
    }
    .cart-count.cart-bump {
        display: inline-block;
        animation: cart-bump 0.45s ease;
    }
</style>

